<template>
    <el-dialog
            title="绑定/解绑 EPC 标签"
            :visible.sync="showEpcDialog"
            :close-on-click-modal=false
            @close="handleCancel"
            width="500px"
    >
        <div>
            <el-form label-width="100px">
                <el-form-item label="EPC 编码">
                    <el-input v-model="epcCode" readonly >
                        <template #append>
                            <el-button @click="copyText" icon="fa fa-fw fa-lg fa-paste"></el-button>
                        </template>
                    </el-input>
                </el-form-item>
                <el-form-item label="标签材质" >
                    <el-select v-model="tagMaterial" placeholder="请选择材质" style="width: 100%">
                        <el-option
                                v-for="item in materialOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                        />
                    </el-select>
                </el-form-item>
            </el-form>
        </div>

        <div slot="footer" class="dialog-footer">
            <el-button @click="handleCancel">取消</el-button>
            <el-button type="primary" :disabled="!tagMaterial||!epcCode" @click="handleConfirm">确定
            </el-button>
            <el-button type="danger" :disabled="!loading||!epcCode" @click="handleUnBind">解除绑定</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: 'EpcBindDialog',
    props: {
        bindId: {
            type: [String, Number],
            required: true
        },
        tagBusinessCode: {
            type: Number,
            required: true
        },
        visible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showEpcDialog: false,
            epcCode: '',
            tagMaterial: '',
            loading: false,
            materialOptions: [
            ]
        };
    },
    watch: {
        visible(newVal) {
            this.showEpcDialog = newVal;
            if (newVal) {
                this.fetchEpcMaterialOptions();
                this.fetchEpcCode();
            }
        },
        showEpcDialog(newVal) {
            this.$emit('update:visible', newVal);
        }
    },
    methods: {
        copyText() {
            navigator.clipboard.writeText(this.epcCode).then(() => {
                this.$message.success('复制成功');
            });
        },
        fetchEpcMaterialOptions() {
            if (this.materialOptions.length>0) {
                return
            }
            let params = {
                numRegPag: 200
            };
            this.$store.dispatch('api/post', {
                url: process.env.VUE_APP_EM_ARCHIVE_URL + "/emEpcTagMaterial/findByFilter",
                data: params,
            }).then(response => {
                if (response&& response.data && response.data.list && response.data.list.length > 0) {
                    console.log("response",response.data)
                    this.materialOptions = response.data.list.map(item => {
                        return {
                            value: item.id,
                            label: item.tagSize?item.tagMaterialName+"("+item.tagSize+")":item.tagMaterialName
                        }
                    });
                }
            })

        },
        async fetchEpcCode() {
            this.loading = true;
            let params = {
                epcCode: this.epcCode,
                bindId: this.bindId,
                tagBusinessCode: this.tagBusinessCode,
                tagMaterialCode: this.tagMaterial
            };
            try {
                this.loading  = true;
                await this.$store.dispatch('api/post', {
                    url: process.env.VUE_APP_EM_ARCHIVE_URL + "/emEpcTag/generateEpcCode",
                    data: params,
                }).then(response => {
                    if (response && response.data) {
                        this.epcCode = response.data;
                    }
                })
            } catch (e) {
                this.loading  = false;
                this.$message.error('生成epc code失败');
            }
        },
        async handleConfirm() {
            let params = {
                epcCode: this.epcCode,
                bindId: this.bindId,
                tagBusinessCode: this.tagBusinessCode,
                tagMaterialId: this.tagMaterial
            };
            try {
                this.loading  = true;
                await this.$store.dispatch('api/post', {
                    url: process.env.VUE_APP_EM_ARCHIVE_URL + "/emEpcTag/bindEpcCode",
                    data: params,
                }).then(response => {
                    if (response && response.data) {
                        this.$message.success("绑定成功");
                    }
                })
                this.$emit('success');
                this.reset();
            }  finally {
                this.loading  = false;
                this.showEpcDialog = false;
            }
        },
        async handleUnBind() {
            let params = {
                epcCode: this.epcCode,
                bindId: this.bindId,
                tagBusinessCode: this.tagBusinessCode,
            };
            try {
                await this.$store.dispatch('api/post', {
                    url: process.env.VUE_APP_EM_ARCHIVE_URL + "/emEpcTag/unBindEpcCode",
                    data: params,
                }).then(response => {
                    if (response && response.data) {
                        this.$message.success("解绑成功");
                    }
                })
                this.$emit('success');
                this.reset();
            } finally {
                this.showEpcDialog = false;
            }
        },
        handleCancel() {
            this.showEpcDialog = false;
            this.$emit('cancel');
            this.reset();
        },
        reset() {
            this.epcCode = '';
            this.tagMaterial = '';
        },
    },
};
</script>
